export const normalizeBeneficiaries = (list = []) => {
  if (!Array.isArray(list)) return [];
  return list.map((beneficiary, index) => {
    const rawPercentage = beneficiary.percAllocValue ?? beneficiary.perc_alloc ?? beneficiary.percentage_allocation ?? beneficiary.percentage ?? 0;
    const percAllocValue = typeof rawPercentage === 'number'
      ? rawPercentage
      : Number(String(rawPercentage || '').replace(/[^0-9.]/g, '')) || 0;

    return {
      beneficiaryId: beneficiary.beneficiaryId ?? beneficiary.beneficiary_id ?? beneficiary.id ?? `beneficiary-${index}`,
      name: beneficiary.name || beneficiary.FullName || beneficiary.full_name || '',
      relationship: beneficiary.relationship || beneficiary.Relationship || '',
      dob: beneficiary.dob || beneficiary.birth_date || '',
      address: beneficiary.address || '',
      percAllocValue,
      percentage: percAllocValue
        ? `${percAllocValue}%`
        : (typeof rawPercentage === 'string' ? rawPercentage : '0%'),
    };
  });
};

export const extractBeneficiaryListFromResponse = (response) => {
  const candidates = [
    response?.data?.beneficiary,
    response?.data?.beneficiaries,
    response?.beneficiary,
    response?.beneficiaries,
    response?.data?.data?.beneficiary,
    response?.data?.data?.beneficiaries,
  ];
  return candidates.find(Array.isArray) || [];
};

export const toISODateInput = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (!Number.isNaN(date.getTime())) {
    return date.toISOString().slice(0, 10);
  }
  if (typeof value === 'string' && value.includes(' ')) {
    return value.split(' ')[0];
  }
  return value;
};

export const formatBeneficiaryPercentage = (beneficiary) => {
  if (typeof beneficiary?.percAllocValue === 'number') {
    return `${beneficiary.percAllocValue}%`;
  }
  return beneficiary?.percentage || '0%';
};

export const getInitials = (name = '') => {
  const parts = name
    .replace(/-/g, ' ')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  return parts.slice(0, 2).map((part) => part.charAt(0).toUpperCase()).join('');
};

export const sanitizePercentValue = (value) => {
  if (typeof value === 'number' && !Number.isNaN(value)) return value;
  if (typeof value === 'string') {
    const cleaned = Number(value.replace(/[^0-9.]/g, ''));
    return Number.isNaN(cleaned) ? 0 : cleaned;
  }
  return 0;
};
